import {
    Box,
    Button,
    Grid,
    makeStyles,
    Typography,
  } from "@material-ui/core";
  import instance from "api/globalaxios";
  import Axios from "axios";
  import { format } from "date-fns";
  import CircularCenteredLoader from "features/common/CircularCenteredLoader";
  import debounce from "lodash.debounce";
  import React, { useCallback, useEffect, useState } from "react";
  import { useDispatch } from "react-redux";
  import { useHistory } from "react-router-dom";
  import { isMuthoot } from "Routes/Routes";
import Tabs from "features/Tabs/Tabs";
import { Add } from "@material-ui/icons";
import { Pagination } from "@material-ui/lab";
import SearchBar from "Components/SearchBar";
import Table from "Components/Table/Table";
import { isValidNumber, isValidDate, isValidOrixId, ALPHANUMERIC_REGEX } from "../utils/util";
  
  const useStyles = makeStyles((theme) => ({
    root: {
      padding: "3rem",
      [theme.breakpoints.down("sm")]: {
        padding: "1.5rem",
      },
    },
    content: {
      [theme.breakpoints.down("sm")]: {
        marginTop: "3rem",
      },
    },
    bigheading: {
      color: isMuthoot ? 'black' : "#4F4F4F",
      // fontFamily: `'Inter',sans-serif`,
      fontWeight: "400",
      fontSize: "24px",
      lineHeight: "36px",
      textTransform: "capitalize",
      [theme.breakpoints.down("xs")]: {
        fontSize: "20px",
      },
    },

    spaceBox: {
      height: "4rem",
      [theme.breakpoints.down("sm")]: {
        height: "3rem",
      },
      [theme.breakpoints.down("xs")]: {
        height: "2rem",
      },
    },
    griditem: {
      padding: "8px",
      [theme.breakpoints.down("xs")]: {
        padding: "4px",
      },
    },

    tabsContainer: {
      border: '1px solid black',
      [theme.breakpoints.down("sm")]: {
        width: '100%',
        flexWrap: 'wrap',
      },
    },
    selected: {
      padding: "9.8px 14.7px",
      cursor: 'pointer',
      fontSize: '14.7px',
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      textAlign: 'center',
      backgroundColor: 'white',
    },
    unselected: {
      fontSize: '14.7px',
      padding: "9.8px 14.7px",
      cursor: "pointer",
      fontFamily: 'Satoshi-Medium',
      minWidth: 'fit-content',
      textAlign: 'center',
    },
    highlightRow: {
      background: '#2bb87914',
      '& td': {
        fontFamily: 'Satoshi-Bold',
      },
      '& > *:first-child': {
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          height: '100%',
          width: 4,
          background: '#2bb879',
          borderRadius: '2px 0 0 2px',
          display: 'block',
        },
      },
    },
  }));
  
  
  export default function DisputesOrixUser({
    disputesLoading,
    setType,
    type,
    disputes,
    reload,
    profile,
    totalPages,
    currentPage,
    getUserDataAnotherPage,
  }) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
  
    const [searchText, setSearchText] = useState("");
    const [disputesBySearch, setDisputesBySearch] = useState(disputes);
    const [cancelToken, setCancelToken] = useState();
  
    const debouceSearch = useCallback(debounce(search, 500), [disputes]);

    const processedData = (data) => {
      const result = data.reduce((arr, item) => {
        const transformedObject = { 
          ticketNumber: item.grc_ticket_number, 
          complainDetails: <Typography className="lineClamp" style={{fontFamily:'inherit'}}>{item?.description}</Typography>, 
          timeStamp: item.reopen_date 
            ? format(new Date(item.reopen_date), "dd MMMM, y, h:mm a") 
            : item.submission_date 
              ? format(new Date(item.submission_date), "dd MMMM, y, h:mm a") 
              : '-',
          is_highlighted: item?.unread?.includes(profile?.profile?.profile_type),
          ...item,
        };
        arr.push(transformedObject);
        return arr;
      }, []);
      
      return result;
    };
  
    useEffect(() => {
      setDisputesBySearch(processedData(disputes));
    }, [disputes]);
  
    function search(value, type) {
      //Check if there are any previous pending requests
      if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      let x = Axios.CancelToken.source();
      setCancelToken(x);
  
      if (value.trim() != "") {
        // Input with no letters/digits (e.g. "." or "..") can't match anything, and a
        // dot-only path segment is collapsed by the browser into a 404 -> /fallback.
        if (!ALPHANUMERIC_REGEX.test(value)) {
          setDisputesBySearch([]);
          return;
        }
        let new_value = value.replaceAll('/','-');
        let ar = new_value.trim().split("-");
        let date = new Date(ar[1] + "/" + ar[0] + "/" + ar[2]);
        if (isValidDate(date)) {
          dispatch(getOrixdatabydate(date, x, type));
        } else if (isValidNumber(new_value.trim()) || isValidOrixId(new_value.trim())) {
          dispatch(getOrixdatabyDisputeId(new_value.trim(), x, type));
        } else {
          // Only date and ticket number are searchable here
          setDisputesBySearch([]);
        }
      } else {
        setDisputesBySearch([...processedData(disputes)]);
      }
    }

    function getOrixdatabydate(date, cancelToken, type=null, region=null) {
      return async (dispatch) => {
        try {
          const response = await instance.get(
            `api/orixsearchbydateView/${format(
              date,
              "dd-MM-yyyy"
            )}/?type=${type}&region=${region}`,
            { cancelToken: cancelToken.token, suppressGlobalErrorHandling: true }
          );
          setDisputesBySearch(processedData(response.data));

          return response.data;
        } catch (error) {
          console.log(error);
          if (!Axios.isCancel(error)) setDisputesBySearch([]);
        }
      };
    }

    function getOrixdatabyDisputeId(value, cancelToken, type=null, region=null, days=null) {
      return async (dispatch) => {
        try {
          const response = await instance.get(
            `/api/orixsearchbydisputeidView/${encodeURIComponent(value)}/?type=${type}&region=${region}&days=${days}`,
            { cancelToken: cancelToken.token, suppressGlobalErrorHandling: true }
          );
          setDisputesBySearch(processedData(response.data));

          return response.data;
        } catch (error) {
          console.log(error);
          if (!Axios.isCancel(error)) setDisputesBySearch([]);
        }
      };
    }

    const tabs = [
      {
        id: "open",
        label: "In progress",
      },
      {
        id: "closed",
        label: "Closed",
      },
    ];

    const [currentTab, setCurrentTab] = useState(type);

    const handleTabChange = (newValue) => {
      setCurrentTab(newValue);
      setType(newValue);
      setSearchText("");
      sessionStorage.setItem("orix-type", newValue);
    };

    const columns = [
      { field: 'ticketNumber', headerName: 'Ticket Number', width: '16.66%'},
      { field: 'complainDetails', headerName: 'COMPLAINT DETAILS', width: '66.64%'},
      { field: 'timeStamp', headerName: 'Date & Time', width: '16.66 %'},
    ];

    const onRowClick = (row) => {
      history.push(`/disputes/${row.id}`);
    };
  
    return (
      <>
        <Grid container className={classes.root}>
          <Box className={classes.spaceBox} />
          {disputesLoading ? (
            <CircularCenteredLoader />
          ) : (
            <>
              <Grid container>
                <Grid
                  item
                  className={classes.griditem}
                  style={{ paddingLeft: 0, flex: 1, }}
                >
                  <SearchBar
                    placeholder="Search by Date (DD-MM-YYYY) or Ticket Number"
                    value={searchText}
                    onChange={(value) => {
                      setSearchText(value);
                      debouceSearch(value, type);
                    }}
                    backgroundColor="#f5f5f5"
                    height={42}
                    borderRadius={0}
                    showSearchIcon={true}
                    TextFieldProps={{
                      fullWidth: true,
                    }}
                    // hoverBackgroundColor="#e0e0e0"
                    // textColor="#333"
                    // iconColor="#666"
                    // fontSize={'1rem'}
                    // borderColor="#ccc"
                    // hoverBorderColor="#999"
                    // focusBorderColor="#2196f3"
                  />
                </Grid>
                <Grid item className={classes.griditem}>
                  <Tabs
                    tabs={tabs}
                    handleClickTab={handleTabChange}
                    choice={currentTab}
                    tabsClasses={{
                      selected: classes.selected,
                      unselected: classes.unselected,
                    }}
                    tabsContainerClass={classes.tabsContainer}
                  />
                </Grid>
                <Grid item className={classes.griditem}>
                  <Box>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<Add/>}
                      onClick={() => {
                        history.push("/intro");
                      }}
                      style={{fontSize:'14px',padding:'9px 14.7px'}}
                    >
                      FILE NEW
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              {/* Disputes list starts from here */}
              <Box className={classes.spaceBox}></Box>
              <Table
                data={disputesBySearch}
                columns={columns}
                onRowClick={onRowClick}
                loading={disputesLoading}
                customStyles={{ 
                  tableStyle: { border: '1px solid #e0e0e0' },
                  headerCellStyle: { fontFamily: 'Satoshi-Bold' }, 
                  cellStyle: { fontSize: '1rem', padding: '0.75rem' } 
                }}
                getTableRowClassName={(highlight)=> highlight ? classes.highlightRow : ''}
              />
              <Box height="10px"></Box>
              {disputesBySearch.length !== 0 && !searchText && (
                <div style={{display: 'flex', justifyContent: 'flex-end', padding: '1rem 0', width: '100%'}}>
                  <Pagination color="primary" page={currentPage} count={totalPages} onChange={(event, value)=>getUserDataAnotherPage(value)}/>
                </div>
              )}
            </>
          )}
        </Grid>
      </>
    );
  }
  